import React, { useState, useEffect } from 'react';
import { Container, Card, Table, Button, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FaPlus, FaEdit, FaTrash, FaSortUp, FaSortDown, FaSort, FaSearch } from 'react-icons/fa';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import * as api from '~/Services/Service';
import ModalRegiao from './ModalRegiao';

const Regioes = () => {
  const [regioes, setRegioes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [itemSelecionado, setItemSelecionado] = useState(null);
  const [confirmacao, setConfirmacao] = useState({ show: false, item: null });
  const [filtro, setFiltro] = useState('');
  const [ordenacao, setOrdenacao] = useState({ campo: 'codigo', direcao: 'asc' });

  useEffect(() => {
    carregarRegioes();
  }, []);

  const carregarRegioes = async () => {
    setLoading(true);
    try {
      const resp = await api.obterRegioes();
      setRegioes(resp || []);
    } catch (err) {
      toast.error(err && err.message ? err.message : 'Erro ao carregar regiões.');
    } finally {
      setLoading(false);
    }
  };

  const handleNovo = () => {
    setItemSelecionado(null);
    setShowModal(true);
  };

  const handleEditar = (item) => {
    setItemSelecionado(item);
    setShowModal(true);
  };

  const handleExcluir = (item) => {
    setConfirmacao({ show: true, item: item });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    if (!confirmado) {
      setConfirmacao({ show: false, item: null });
      return;
    }
    const item = confirmacao.item;
    setConfirmacao({ show: false, item: null });
    try {
      await api.excluirRegiao({ codigo: item.codigo });
      toast.success('Região excluída com sucesso.');
      carregarRegioes();
    } catch (err) {
      toast.error(err && err.message ? err.message : 'Erro ao excluir região.');
    }
  };

  const handleSalvar = () => {
    setShowModal(false);
    carregarRegioes();
  };

  const handleFiltro = (e) => {
    setFiltro(e.target.value);
  };

  const handleOrdenacao = (campo) => {
    setOrdenacao((prev) => {
      if (prev.campo === campo) {
        return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
      }
      return { campo: campo, direcao: 'asc' };
    });
  };

  const iconeOrdenacao = (campo) => {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  const thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  const regioesFiltradas = regioes.filter((item) => {
    if (!filtro) return true;
    const termo = filtro.toLowerCase();
    return (
      String(item.codigo).indexOf(termo) >= 0 ||
      (item.descricao || '').toLowerCase().indexOf(termo) >= 0
    );
  });

  const regioesOrdenadas = regioesFiltradas.slice().sort((a, b) => {
    const campo = ordenacao.campo;
    const dir = ordenacao.direcao === 'asc' ? 1 : -1;
    let valA = a[campo];
    let valB = b[campo];
    if (valA == null) valA = '';
    if (valB == null) valB = '';
    if (typeof valA === 'string') {
      return dir * valA.toLowerCase().localeCompare(String(valB).toLowerCase());
    }
    return dir * (valA - valB);
  });

  const itemExclusao = confirmacao.item;

  if (loading) return <Loading />;

  return (
    <Container fluid className="px-3 py-3">
      <style>{'\
        .regioes-desktop { display: block; }\
        .regioes-mobile  { display: none; }\
        @media (max-width: 768px) {\
          .regioes-desktop { display: none !important; }\
          .regioes-mobile  { display: block; }\
          .regioes-filtro-row { flex-direction: column; }\
          .regioes-filtro-row .text-right { text-align: right !important; margin-top: 8px; }\
        }\
      '}</style>

      <Header title="Regiões" />

      <Card className="shadow-sm mb-3">
        <Card.Body className="py-2">
          <Row className="align-items-center regioes-filtro-row">
            <Col md={4}>
              <InputGroup size="sm">
                <InputGroup.Prepend>
                  <InputGroup.Text><FaSearch /></InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  placeholder="Filtrar por código ou descrição..."
                  value={filtro}
                  onChange={handleFiltro}
                />
              </InputGroup>
            </Col>
            <Col className="text-right">
              <Button size="sm" variant="primary" onClick={handleNovo}>
                <FaPlus className="mr-1" /> Nova Região
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Header
          className="d-flex justify-content-between align-items-center py-2"
          style={{ backgroundColor: '#0747a6', color: '#fff' }}
        >
          <strong>
            Regiões
            <span className="ml-2" style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              ({regioesOrdenadas.length} {regioesOrdenadas.length === 1 ? 'registro' : 'registros'})
            </span>
          </strong>
        </Card.Header>
        <Card.Body className="p-0">
          {regioesOrdenadas.length === 0 ? (
            <p className="text-muted text-center my-4">Nenhuma região cadastrada.</p>
          ) : (
            <>
              {/* Desktop */}
              <div className="regioes-desktop">
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead>
                    <tr>
                      <th
                        style={Object.assign({ width: '100px' }, thSortStyle)}
                        onClick={() => { handleOrdenacao('codigo'); }}
                      >
                        Código{iconeOrdenacao('codigo')}
                      </th>
                      <th
                        style={thSortStyle}
                        onClick={() => { handleOrdenacao('descricao'); }}
                      >
                        Descrição{iconeOrdenacao('descricao')}
                      </th>
                      <th style={{ width: '90px', textAlign: 'center' }}>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {regioesOrdenadas.map((r) => {
                      return (
                        <tr key={r.codigo}>
                          <td>{r.codigo}</td>
                          <td>{r.descricao}</td>
                          <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                            <Button
                              size="sm"
                              variant="outline-warning"
                              title="Editar"
                              className="mr-1"
                              onClick={() => { handleEditar(r); }}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              size="sm"
                              variant="outline-danger"
                              title="Excluir"
                              onClick={() => { handleExcluir(r); }}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {/* Mobile */}
              <div className="regioes-mobile p-2">
                {regioesOrdenadas.map((r) => {
                  return (
                    <Card key={r.codigo} className="mb-2 shadow-sm">
                      <Card.Body className="py-2 px-3">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <div>
                            <strong style={{ fontSize: '0.95rem' }}>{r.descricao}</strong>
                            <br />
                            <small className="text-muted">Código: {r.codigo}</small>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end">
                          <Button
                            size="sm"
                            variant="outline-warning"
                            className="mr-1"
                            onClick={() => { handleEditar(r); }}
                          >
                            <FaEdit className="mr-1" /> Editar
                          </Button>
                          <Button
                            size="sm"
                            variant="outline-danger"
                            onClick={() => { handleExcluir(r); }}
                          >
                            <FaTrash className="mr-1" /> Excluir
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      <ModalConfirmacao
        show={confirmacao.show}
        title="Confirmar Exclusão"
        message={
          itemExclusao
            ? 'Deseja realmente excluir a região "' + (itemExclusao.descricao || '') + '"?'
            : ''
        }
        onClose={handleConfirmarExclusao}
      />

      <ModalRegiao
        show={showModal}
        onHide={() => { setShowModal(false); }}
        regiao={itemSelecionado}
        onSalvar={handleSalvar}
      />
    </Container>
  );
};

export default Regioes;
